import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getToEmailList = async () => {
    try {
        const response = await axiosApi.get(`/Iom/getToEmailList`);
        return response?.data;
    } catch (error) {
        console.log("Error getCityList===>:", error);
    }
};

const getIOMList = async (body) => {
    try {
        let body1 = body || {};
        body1.companyId = getReduxCompany()?.companyId || 1;
        const response = await axiosApi.post(`/Iom/GetIomList`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMList===>:", error);
    }
};

const getIomDetailForEdit = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;
        const response = await axiosApi.post(`/Iom/GetIomDetailForEdit`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIomDetailForEdit===>:", error);
    }
};

const getIOMDetailsByIOMId = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/Iom/GetIomDetailsByIomId`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMDetailsByIOMId===>:", error);
    }
};

const createInterOfficeMemorandumV2 = async (request) => {
    try {
        var response = await axiosApi.post(`/Iom/createInterOfficeMemorandumV2`, request, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response?.data;
    } catch (error) {
        console.log("Error createInterOfficeMemorandumV2===>:", error);
        return response?.data;
    }
};

const updateIom = async (request) => {
    try {
        var response = await axiosApi.post(`/Iom/UpdateInterOfficeMemorandumV3`, request, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response?.data;
    } catch (error) {
        console.log("Error updateIom===>:", error);
        return response?.data;
    }
};

const deleteIOM = async (request) => {
    //debugger;
    try {
        var response = await axiosApi.post(`/Iom/DeleteIOM`, request, {
            // headers: {
            //     'Content-Type': 'multipart/form-data'
            // }
        });
        return response?.data;
    } catch (error) {
        console.log("Error DeleteIOM===>:", error);
        return response?.data;
    }
};

const approveIOM = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/ApproveIOM`, body);
        return response?.data;
    } catch (error) {
        console.log("Error approveIOM===>:", error);
        return error?.response;
    }
};

const approveRecallRequestIOM = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/ApproveRecallRequestIOM`, body);
        return response?.data;
    } catch (error) {
        console.log("Error approveRecallRequestIOM===>:", error);
        return error?.response;
    }
};

const requestToRecallIOM = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/RequestToRecallIOM`, body);
        return response?.data;
    } catch (error) {
        console.log("Error requestToRecallIOM===>:", error);
        return error?.response;
    }
};
const reviewIom = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/ReviewdIOMyReviewer`, body);
        return response?.data;
    } catch (error) {
        console.log("Error reviewIom===>:", error);
        return error?.response;
    }
};

const rejectIOM = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/RejectIOM`, body);
        return response?.data;
    } catch (error) {
        console.log("Error rejectIOM===>:", error);
        return error?.response;
    }
};
const sentIOMForReview = async (body) => {
    try {
        const response = await axiosApi.post(`/Iom/SendIOMForReview`, body);
        return response?.data;
    } catch (error) {
        console.log("Error sentIOMForReview===>:", error);
        return error?.response;
    }
};

const getIOMRemarksByIomId = async (iomId) => {
    try {
        const response = await axiosApi.get(`/Iom/GetRemarksByIomId/` + iomId);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMRemarksByIomId===>:", error);
    }
};

const getIOMAttachmentsByIomId = async (iomId) => {
    try {
        const response = await axiosApi.get(`/Iom/GetIOMAttachmentsByIomId/` + iomId);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMAttachmentsByIomId===>:", error);
    }
};

const checkUserDesignationForIOMApproval = async (userDesignationId) => {
    try {
        const response = await axiosApi.post(`/Iom/CheckUserDesignationForIOMApproval/` + userDesignationId);
        return response?.data;
    } catch (error) {
        console.log("Error checkUserDesignationForIOMApproval===>:", error);
    }
};

const getPreviousApprovedStatus = async (iomId, userId) => {
    try {
        const response = await axiosApi.get(`/Iom/CheckPreviousApproveStatus/` + iomId + "/" + userId);
        return response?.data;
    } catch (error) {
        console.log("Error getPreviousApprovedStatus===>:", error);
    }
};
const CheckApproveStatus = async (iomId, userId) => {
    try {
        const response = await axiosApi.get(`/Iom/CheckApproveStatus/` + iomId + "/" + userId);
        return response?.data;
    } catch (error) {
        console.log("Error CheckApproveStatus===>:", error);
    }
};

const getIOMUserForReject = async (iomId, userId) => {
    try {
        let companyId = getReduxCompany()?.companyId || 1;
        const response = await axiosApi.get(`/Iom/GetIomUserForReject/` + iomId + `/` + userId + `/` + companyId);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMUserForReject===>:", error);
    }
};

const getIOMStatusDropdown = async (body) => {
    try {
        const response = await axiosApi.post(`IOM/GetIOMStatusDropdown`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMStatusDropdown===>:", error);
    }
};

const getIOMNoDropdown = async (userId) => {
    try {
        let companyId = getReduxCompany()?.companyId || 1;
        const response = await axiosApi.post(`IOM/GetIOMNoByUserId/${userId}/${companyId || 1}`);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMNoDropdown===>:", error);
    }
};

const getIOMReport = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;
        const response = await axiosApi.post(`/Iom/GetIOMReport`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMReport===>:", error);
    }
};


export const IOMService = {
    getToEmailList,
    createInterOfficeMemorandumV2,
    getIOMList,
    getIomDetailForEdit,
    approveIOM,
    approveRecallRequestIOM,
    requestToRecallIOM,
    rejectIOM,
    updateIom,
    deleteIOM,
    getIOMRemarksByIomId,
    getIOMAttachmentsByIomId,
    checkUserDesignationForIOMApproval,
    getIOMDetailsByIOMId,
    getPreviousApprovedStatus,
    getIOMUserForReject,
    getIOMStatusDropdown,
    getIOMNoDropdown,
    sentIOMForReview,
    reviewIom,
    CheckApproveStatus,
    getIOMReport,
}